import StyleProvider, { StyletronEngine } from '@thanx/uikit/StyleProvider'
import ErrorBoundary from 'components/ErrorBoundary'
import FlagsProvider from 'components/FlagsProvider'
import { AIChatConnectionProvider } from 'contexts/AIChatConnectionProvider'
import { WebSocketProvider } from 'contexts/WebSocketContext'
import React from 'react'
import { Provider as ReduxProvider } from 'react-redux'
import store from 'store'
import { generateUikitTheme } from 'theme'

type Props = {
  children: React.ReactNode
}

const styletronEngine = new StyletronEngine({ prefix: 'st-' })

const AppProviders: React.FC<Props> = ({ children }) => {
  const uikitTheme = generateUikitTheme()
  return (
    <StyleProvider
      styletronEngine={styletronEngine}
      theme={uikitTheme}
      overrides={{
        AppContainer: {
          style: {
            height: '100%',
          },
        },
      }}
    >
      <ReduxProvider store={store}>
        {/* Inside StyleProvider + ReduxProvider (both needed to render the
            ErrorPage fallback), but above the socket/AI/flags providers so a
            throw in any of them is caught rather than blanking the page. */}
        <ErrorBoundary>
          <WebSocketProvider>
            <AIChatConnectionProvider>
              <FlagsProvider>{children}</FlagsProvider>
            </AIChatConnectionProvider>
          </WebSocketProvider>
        </ErrorBoundary>
      </ReduxProvider>
    </StyleProvider>
  )
}

export default AppProviders
